import isDraftFilterAtLocation from "qpr-base/attributes/drafts/disabledPages";
import Query from "qpr-base/querybuilder/Query";
import defaultAttributes from "./defaultAttributes";
import { convertItemListToPeriod } from "./model/convertItemListToPeriod";
import { ICardElementWithChildren, IPeriod, IPeriodLevel } from "./model/model";

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}
const getValues = async (
  elementId: string | string[],
  periods: IPeriod[],
  notExactPeriod = false,
  periodLevels: IPeriodLevel[],
  attributes?: any
): Promise<Array<ICardElementWithChildren>> => {
  let allPeriods = [...periods];
  const valuesPromise: Promise<ICardElementWithChildren | null>[] = [];

  // TODO: use matchElementPeriodToRequestedPeriod to map the elements period
  // to correct period level for the element, this is a bit tricky thing to do I think...

  const attr = attributes || defaultAttributes;

  allPeriods.forEach((period) => {
    const elementIdList = Array.isArray(elementId) ? elementId : [elementId];
    elementIdList.forEach((id) => {
      valuesPromise.push(
        Query(id)
          .attributes(...attr(period.name, periodLevels))
          .allowDraft(!isDraftFilterAtLocation())
          .fetchValues<ICardElementWithChildren>()
          .then((valuelist) => {
            return convertItemListToPeriod(valuelist, period, periodLevels);
          })
          .then((valuelist) => {
            const [res] = valuelist;
            if (
              (res.periodlevelid || res.periodlevel) !== period.periodlevel &&
              !notExactPeriod
            ) {
              return null;
            }
            return {
              ...res,
            };
          })
      );
    });
  });
  const valuesFrom = await Promise.all(valuesPromise);
  const finalValues: ICardElementWithChildren[] = valuesFrom.filter(notEmpty);
  return finalValues;
};
export default getValues;
